<template>
  <div>
    <div class="abs fs-40 vi-color" style="right: 50px; top: 10px">
      {{`${countdown / 60}`.split('.')[0]}}:{{countdown % 60}}
    </div>
    <el-table
      :default-expand-all="true"
      :data="exam.questions"
      :show-header="false">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div class="ml-80">
            <li class="lh-30 fs-15" v-for="(item,i) in scope.row.optionContentList" :key="item.optionId">
              <el-checkbox class="mr-10" v-model="item.isSelect" @change="onOptionChange(item,scope.row.optionType, scope.row.optionContentList)">
                {{String.fromCharCode(65+i)}}、{{item.optionContent}}
              </el-checkbox>
            </li>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="questionContent">
        <template slot-scope="scope">
          <div class="fs-15">
            <span class="vi-color">（{{optionMap[scope.row.optionType]}}）</span>{{scope.$index + 1}} 、 {{scope.row.questionContent}}            
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="ta-c mt-30">
      <el-button type="primary" @click="submitExam">我已完成作答，并提交试卷</el-button>
    </div>
    <el-dialog :append-to-body="true" class="rel" width="400px" :visible.sync="reportState" title="本次考试成绩单">
      <el-descriptions class="ml-40" :column="1">
        <el-descriptions-item label="试卷成绩">{{examReport.totalScore}}</el-descriptions-item>
        <el-descriptions-item label="答对题数">{{examReport.trueNumber}}</el-descriptions-item>
        <el-descriptions-item label="答错题数">{{examReport.falseNumber}}</el-descriptions-item>
        <el-descriptions-item label="正确率">{{examReport.correctRate * 100}}%</el-descriptions-item>
        <el-descriptions-item label="答题用时">{{`${`${examReport.sumExamSecond / 60}`.split('.')[0]} 分 ${examReport.sumExamSecond % 60} 秒`}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{examReport.examStartTime}}</el-descriptions-item>
      </el-descriptions>
      <img class="abs" width="140" style="right: 20px; top: 60px" :src="examReport.isPass ? 'https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/miniStudyPlatform/pass.png' : 'https://caichendaizhang.oss-cn-shenzhen.aliyuncs.com/miniStudyPlatform/nopass.png'" alt="">
      <div class="ta-c">
        <el-button type="primary" @click="reportConfirm"> 确定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  Req_CreateExamDetail,
  Req_SubmitExam,
  Req_GetExamReport
} from '@/ajax/exam'
let timer = null
export default {
  props: {
    subjectId: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      exam: {},
      optionMap: {
        10: '单选',
        20: '多选',
        30: '判断'
      },
      examReport: {},
      reportState: false,
      countdown: null,
      confirmPromise: null
    }
  },
  created() {
    this.getExamDetail()
  },
  methods: {
    reportConfirm() {
      this.reportState = false
      this.$emit('examEnd')
    },
    getSubmitParams() {
      const params = {
        examId: this.exam.examId,
        examDetails: []
      }
      const noSelect = []
      this.exam.questions.forEach((q,i) => {
        const obj = {}
        obj.examDetailId = q.examDetailId
        obj.studentAnswer = []
        let flag = true
        q.optionContentList.forEach(o => {
          if(o.isSelect) {
            flag = false
            obj.studentAnswer.push(o.optionId)
          }
        })
        params.examDetails.push(obj)
        if(flag) {
          noSelect.push(i+1)
        }
      })
      return {
        params,
        noSelect
      }
    },
    submitExam() {
      const {noSelect,params} = this.getSubmitParams()
      if(noSelect.length) {
        return this.confirmPromise =  this.$confirm(`第${noSelect.join('，')}题仍未作答`)
      }
      this.confirmPromise =  this.$confirm('确定提交试卷吗？').then(() => {
        
        clearInterval(timer)
        return Req_SubmitExam(params)
      }).then(res => {
        this.$message.success('已提交')
        this.getReport()
        this.countdown = null
      }).catch(err => this.$catchErr(err))
    },
    getReport() {
      Req_GetExamReport({
        examId: this.exam.examId
      }).then(res => {
        this.examReport = res
        this.reportState = true
      }).catch(err => this.$catchErr(err))
    },
    onOptionChange(item,type,list) {
      if(type == 10 || type == 30) {
        list.forEach(opt => {
          if(opt !== item) {
            opt.isSelect = false
          }
        })
      }
    },
    getExamDetail() {
      Req_CreateExamDetail({
        subjectId: this.subjectId
      }).then(res => {
        this.exam = res
        if(this.exam.examMinute) {
          this.setExamCountdown(this.exam.examMinute * 60)
        }
      }).catch(err => this.$catchErr(err))
    },
    setExamCountdown(countdown) {
      this.countdown = countdown
      timer = setInterval(() => {
        this.countdown --
        if(this.countdown === 0) {
          clearInterval(timer)
        }
      },1000)
    }
  },
  watch: {
    state(nV) {
      if(!nV) {
        clearInterval(timer)
        console.log(timer, '============')
        this.countdown = null
      }else {
        this.getExamDetail()
      }
    },
    countdown(nV) {
      if(nV === 0) {
        clearInterval(timer)
        const box = document.getElementsByClassName('el-message-box')[0]
        if(box) {
          const btn = box.getElementsByClassName('el-message-box__headerbtn')[0]
          btn && btn.click()
        }
        this.$confirm('考试完毕，请提交试卷','',{
          confirmButtonText: '交卷',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          const {params} = this.getSubmitParams()
          return Req_SubmitExam(params)
        }).then(() => {
          this.getReport()
          this.countdown = null
        }).catch(err => this.$catchErr(err))
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Exam/Exam.vue